import React, { useState, useContext, useEffect, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
//not used
//import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

import 'react-vis/dist/style.css';

import { ConfigProvider } from 'antd';
import Axios from 'axios';
import QueryClientProvider from 'QueryClientProvider';

import ls from 'local-storage';
import { ThemeProvider } from 'styled-components';

import baseConstants from '@constants/baseConstants';

import { CUSTOMERS_FILTERS_SET } from '@configs/Filters/CUSTOMERS_FILTERS_SETS';
import { EVENTS_FILTERS_SETS } from '@configs/Filters/EVENTS_FILTERS_SETS';
import { MODELS_FILTERS_SET } from '@configs/Filters/MODELS_FILTERS_SETS';
import { usergui } from '@configs/USERGUI';

import Interceptor from '@libs/Interceptors';
import { migrateLegacyFolders } from '@libs/NwFolders';

import { ListContext } from '@contexts/ListContext';
import { useStateValue } from '@contexts/StateProvider';
import { UserContext, useUserPermission } from '@contexts/UserContext';
import { useUserGuiConfig, useUserGuiConfigDispatch } from '@contexts/UserGuiConfigContext';

import { prefetchRoomConnections } from '@hooks/API/Contact/UseContactConnections';
import {
    prefetchModels,
    prefetchCustomers,
    prefetchContacts as prefetchContactList,
    prefetchPlaylistsCount,
} from '@hooks/API/Contact/UseContactsList';
import { prefetchActivePackages } from '@hooks/API/Packages/UsePackages';
import { prefetchActiveShowSeasons } from '@hooks/API/ShowSeasons/UseShowSeasons';
import { prefetchFeatures, prefetchFeatureSets, prefetchConversions } from '@hooks/API/UseFeatures';
import { forceReloadFolders, prefetchFolders } from '@hooks/API/UseFolders';

import DocumentLayout from '@components/_LayoutComponents/Layout/DocumentLayout';
import NwLayout from '@components/_LayoutComponents/Layout/NwLayout';

import { RouteLoading } from '@components/Gui/Loading';
import StyleVariables from '@components/Gui/StyleVariables';

import './App.less';
import { registerLicense } from '@syncfusion/ej2-base';
import en_GB from 'antd/lib/locale-provider/en_GB';
import 'moment/locale/en-gb';
import 'moment/locale/en-nz';

registerLicense('ORg4AjUWIQA/Gnt2U1hhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5adkZiWH9bdHFTRGlf');

// import ModelDetailsMobile from '@components/ContactDetails/ModelDetails/ModelDetailsIndexMobile';
// import ModelDetailsIndex, { ModelDetailsBook, ModelDetailsHome, ModelDetailsMedia } from '@components/ContactDetails/ModelDetails/ModelDetailsIndex';

// VERSIONE CKEDITOR NON USATA
// import DocEditor from '@containers/Booking/DocEditor/DocEditor';
// import { isDocumentPage } from '@libs/NwUtils';

const User = React.lazy(() => import('Containers/User'));
const Login = React.lazy(() => import('Containers/Authentication/Login'));
const ForgotPassword = React.lazy(() => import('Containers/Authentication/ForgotPassword'));
const ResetPassword = React.lazy(() => import('Containers/Authentication/ResetPassword'));
const PersonalModelsReport = React.lazy(() => import('Containers/User/Reports/PersonalModelsReport'));
const PersonalClientsReport = React.lazy(() => import('Containers/User/Reports/PersonalClientsReport'));

const MailReportPage = React.lazy(() => import('Components/MailReport/MailReportPage'));

const BookingDashboard = React.lazy(() => import('Containers/Booking/Dashboard/Dashboard'));
const MobileHomePage = React.lazy(() => import('Containers/Booking/Mobile/MobileHomePage'));

const SearchTasks = React.lazy(() => import('Containers/Booking/SearchTasks/SearchTasks'));

const ModelsPage = React.lazy(() => import('Components/ContactDetails/ModelDetails/ModelsPage'));
const ModelDetailsResponsive = React.lazy(
    () => import('Components/ContactDetails/ModelDetails/ModelDetailsResponsive')
);
const ModelDetailsAccounting = React.lazy(
    () => import('Components/ContactDetails/ModelDetails/ModelDetailsAccounting')
);
const CustomerDetailsAccounting = React.lazy(
    () => import('Components/ContactDetails/CustomerDetails/CustomerDetailsAccounting')
);
//const ModelDetailsMobile = React.lazy(() => import('Components/ContactDetails/ModelDetails/ModelDetailsIndexMobile'));
//const ModelDetailsHome = React.lazy(() => import('Components/ContactDetails/ModelDetails/ModelDetailsIndex').then(module => ({ default: module.ModelDetailsHome })));

const ModelDetailsMedia = React.lazy(() =>
    import('Components/ContactDetails/ModelDetails/ModelDetailsIndex').then((module) => ({
        default: module.ModelDetailsMedia,
    }))
);

const ModelsArchive = React.lazy(() => import('@containers/ContactsArchive/ModelsArchive'));
const Rooms = React.lazy(() => import('Containers/Booking/Rooms'));
const ModelsLegalSearch = React.lazy(() => import('Containers/Booking/ModelsLegalSearch/ModelsLegalSearch'));
const ModelDataUpdates = React.lazy(() => import('Containers/Booking/ModelDataUpdates/ModelDataUpdates'));

const ProjectPage = React.lazy(() => import('Components/Project/ProjectPage'));
const ScheduleContainerWrapper = React.lazy(() => import('Containers/Booking/Schedule/ScheduleContainerWrapper'));
const EventsSearch = React.lazy(() => import('Containers/Booking/SearchEvents/EventsSearch'));
const EventsReportPage = React.lazy(() => import('Containers/Booking/Reports/EventsReport/EventsReportPage'));
const UsagesSearchPage = React.lazy(() => import('Components/UsagesSearch/UsagesSearchPage'));
const ProjectDraftsPage = React.lazy(() => import('Containers/Booking/ProjectDrafts/ProjectDraftsPage'));
const ShowSeasons = React.lazy(() => import('Containers/Booking/ShowSeasons'));
const DUEPage = React.lazy(() => import('Components/DUE/DUEPage'));

const Packages = React.lazy(() => import('Containers/Booking/Packages/Packages'));

const CustomersPage = React.lazy(() => import('Components/ContactDetails/CustomerDetails/CustomersPage'));
const CustomerDetailsResponsive = React.lazy(
    () => import('Components/ContactDetails/CustomerDetails/CustomerDetailsResponsive')
);
const MailingListsWrapper = React.lazy(() => import('@components/MailingLists/MailingListsWrapper'));
const CustomersArchive = React.lazy(() => import('Containers/ContactsArchive/CustomersArchive/'));

const ScoutingDashboard = React.lazy(() => import('Containers/Scouting/Dashboard'));
const ScoutingMeetings = React.lazy(() => import('Containers/Scouting/ScoutingMeetings/ScoutingMeetingsSearch'));
const TravelPlansSearch = React.lazy(() => import('Containers/Scouting/TravelPlans/TravelPlansSearch'));
const TravelPlan = React.lazy(() => import('Containers/Scouting/TravelPlans/TravelPlan/TravelPlan'));
const Applications = React.lazy(() => import('@containers/Scouting/Applications/Applications'));

const AccountingDashboard = React.lazy(() => import('Containers/Accounting/Dashboard'));
const BillingProjects = React.lazy(() => import('Containers/Accounting/Billing/Projects/BillingProjects'));
const StatementsSearch = React.lazy(() => import('@containers/Accounting/Statements/Search/StatementsSearch'));
const BillingExpenses = React.lazy(() => import('Containers/Accounting/Billing/Expenses/BillingExpenses'));
const BillingCommissions = React.lazy(() => import('Containers/Accounting/Billing/Commissions/BillingCommissions'));
const BillingCommissionsIntegratedSearch = React.lazy(
    () => import('Containers/Accounting/Billing/Commissions/Integrated/BillingCommissionsIntegratedSearch')
);
const Invoices = React.lazy(() => import('Containers/Accounting/Invoices/Invoices'));
const PaymentsWrapper = React.lazy(() => import('Containers/Accounting/Payments/PaymentsWrapper'));
const InvoicePageWrapper = React.lazy(() => import('Containers/Accounting/Invoices/InvoicePageWrapper'));
const BalanceReport = React.lazy(() => import('Containers/Accounting/BalanceReport/BalanceReport'));
const ClientsReport = React.lazy(() => import('Containers/Accounting/Reports/ClientsReport'));
const ModelsReport = React.lazy(() => import('Containers/Accounting/Reports/ModelsReport'));
const BookersReport = React.lazy(() => import('Containers/Accounting/Reports/BookersReport'));
const CommissionsAsMotherAgencyReport = React.lazy(
    () => import('Containers/Accounting/Reports/CommissionsAsMotherAgencyReport')
);
const MotherAgencyCommissionsReport = React.lazy(
    () => import('Containers/Accounting/Reports/MotherAgencyCommissionsReport')
);
const WorkDatesReportPage = React.lazy(
    () => import('Containers/Accounting/Reports/WorkDatesReport/WorkDatesReportPage')
);
const InvoicesReport = React.lazy(() => import('Containers/Accounting/Invoices/InvoicesReport'));
const MassiveExpensesWrapper = React.lazy(
    () => import('@containers/Accounting/MassiveExpenses/MassiveExpensesWrapper')
);
const AccountingAdmin = React.lazy(() => import('Containers/Accounting/Admin'));

// Dashboard dell'area Art temporaneamente disabilitata: la landing e' /art/website
//const ArtDashboard = React.lazy(() => import('Containers/Art/Dashboard/Dashboard'));
const ArtNews = React.lazy(() => import('Containers/Art/News/News'));
const ArtArticles = React.lazy(() => import('Containers/Art/Articles/Articles'));
const ArtGalleries = React.lazy(() => import('Containers/Art/Galleries/Galleries'));
const ArtUploads = React.lazy(() => import('Containers/Art/Uploads/UploadsPage'));
const ArtModelContents = React.lazy(() => import('Containers/Art/ModelContents/ModelContentsPage'));
const ArtWebsites = React.lazy(() => import('@containers/Management/WebsiteManagement/Websites/Websites'));

//const ManagementDashboard = React.lazy(() => import('Containers/Management/Dashboard'));
const ManagementModelsPage = React.lazy(() => import('Containers/Management/Models/ManagementModelsPage'));
const ManagementCustomersPage = React.lazy(() => import('Containers/Management/Customers/ManagementCustomersPage'));
const WebsiteManagement = React.lazy(() => import('Containers/Management/WebsiteManagement'));
const ApplicationFormsManagement = React.lazy(
    () => import('Containers/Management/ApplicationFormsManagement/applicationFormsPage')
);
const UserManagement = React.lazy(() => import('Containers/Management/UserManagement'));
const UserPoliciesPage = React.lazy(() => import('Containers/Management/UserPolicies/UserPoliciesPage'));
const ConfigurationsPage = React.lazy(() => import('Containers/Management/Configuration/ConfigurationsPage'));
const ImportDataPage = React.lazy(() => import('Containers/Management/ImportData/ImportDataPage'));
const AgenciesDepartments = React.lazy(() => import('Containers/Management/AgenciesDepartments'));

const ImageEditorTest = React.lazy(() => import('Components/MediaDrawer/EditImageNew'));

// Mappa una conversion (da useGlobalConversions) nella preferenza metrica da salvare.
// Persiste solo i campi usati, escludendo la lista pesante ConversionValues:
// quest'ultima è sempre disponibile a runtime tramite useGlobalConversions.
const buildMetricPref = (conversion) => ({
    ID: conversion.ID,
    Name: conversion.Name,
    name: conversion.Name,
    AvailableMetrics: conversion.AvailableMetrics,
    metrics: conversion.AvailableMetrics.split(','),
});

// Sanifica una preferenza metrica già salvata rimuovendo i ConversionValues pesanti,
// preservando la selezione/ordinamento scelti dall'utente (.metrics).
const sanitizeMetricPref = (metric) => ({
    ID: metric.ID,
    Name: metric.Name,
    name: metric.name || metric.Name,
    AvailableMetrics: metric.AvailableMetrics,
    metrics: metric.metrics,
});

// Smart list delle wall gestite dal NavigationReducer: Name del record su /userclientconfigurations
// → azione del reducer che le ripristina. Ogni record ha la forma { smartList: [...] }.
const WALL_SMART_LISTS = [
    { name: 'job-smart-list', actionType: 'JobSaveCustomSets' },
    { name: 'travelplan-smart-list', actionType: 'TravelPlanSaveCustomSets' },
    { name: 'package-smart-list', actionType: 'PackageSaveCustomSets' },
    { name: 'invoice-smart-list', actionType: 'InvoiceSaveCustomSets' },
    { name: 'payment-smart-list', actionType: 'PaymentsFiltersSaveCustomSets' },
    { name: 'statement-smart-list', actionType: 'StatementSaveCustomSets' },
    { name: 'todo-smart-list', actionType: 'TaskSaveCustomSets' },
];

const RequireAuth = ({ children }) => {
    const userContext = useContext(UserContext);
    const isAuthenticated = userContext.currentUser;
    return isAuthenticated ? children : <Navigate to={'/login'} />;
};

const RequirePolicy = ({ children, fallback, policyName }) => {
    const isAllowed = useUserPermission(policyName);
    return isAllowed ? children : <Navigate to={fallback} replace />;
};

const App = () => {
    const userContext = useContext(UserContext);
    const listContext = useContext(ListContext);

    const [isLoading, setIsLoading] = useState(false);

    const [prefetched, setPrefetched] = useState(false);

    const [{ areaContext }, dispatch] = useStateValue();

    const userGuiConfig = useUserGuiConfig();
    const ugc_dispatch = useUserGuiConfigDispatch();

    useEffect(() => {
        if (prefetched) {
            listContext.LoadData().catch((error) => {
                console.error('ERROR', error);
            });
        }
    }, [prefetched]);

    useEffect(() => {
        if (listContext.cachedListLoaded) {
            setIsLoading(false);
        }
    }, [listContext.cachedListLoaded]);

    const getUserClientConfigurations = async (conversions) => {
        try {
            const userGuiConfigurations = await Axios.get('/userclientconfigurations');
            if (userGuiConfigurations && userGuiConfigurations.length > 0) {
                //le folder vivono sul database: quelle rimaste in configurazione si migrano una volta sola
                const foldersData = userGuiConfigurations.find((configuration) => configuration.Name === 'folders');
                const migratedFolders = await migrateLegacyFolders(
                    foldersData && foldersData.JsonData ? foldersData.JsonData.openFolders : []
                );
                if (migratedFolders > 0) {
                    forceReloadFolders();
                }

                const settingData = userGuiConfigurations.find((configuration) => configuration.Name === 'settings');

                if (settingData && settingData.JsonData && settingData.JsonData.settings) {
                    var savedSettings = { ...settingData.JsonData.settings };
                    //if there are no metrics, set them as default values: all metrics
                    if (!savedSettings.metrics || savedSettings.metrics.length === 0) {
                        savedSettings.metrics = conversions ? conversions.map(buildMetricPref) : [];
                    } else {
                        //sanifica le preferenze già salvate rimuovendo i ConversionValues pesanti
                        savedSettings.metrics = savedSettings.metrics.map(sanitizeMetricPref);
                        //I need to check if there is some conversion that is not in the savedSettings.metrics. In case add it mapped as above
                        // aggancio sull'ID: due conversion table possono avere lo stesso Name ma ID diversi,
                        // e le preferenze si rileggono sempre per ID (metricPrefByConversionId)
                        const newConversions = conversions
                            ? conversions.filter(
                                  (conversion) => !savedSettings.metrics.find((metric) => metric.ID === conversion.ID)
                              )
                            : [];
                        if (newConversions.length > 0) {
                            savedSettings.metrics.push(...newConversions.map(buildMetricPref));
                        }
                    }
                    ugc_dispatch({ type: 'Update', value: savedSettings });
                } else {
                    //if there are no settings at all, set at least the metrics as default values: all metrics
                    const newsettings = {
                        ...usergui,
                        metrics: conversions ? conversions.map(buildMetricPref) : [],
                    };
                    ugc_dispatch({ type: 'Update', value: newsettings });
                }

                const alertsData = userGuiConfigurations.find((configuration) => configuration.Name === 'alerts');
                if (alertsData) {
                    for (const area of baseConstants.AREAS) {
                        ls.set(`nw_config_${area}-read-alerts`, alertsData.JsonData[area] || []);
                    }
                }

                const modelSmartListData = userGuiConfigurations.find(
                    (configuration) => configuration.Name === 'model-custom-smart-lists'
                );
                const modelSmartLists = [...MODELS_FILTERS_SET.staticSets];
                if (modelSmartListData) {
                    if (
                        modelSmartListData.JsonData.customSmartLists &&
                        modelSmartListData.JsonData.customSmartLists.length > 0
                    ) {
                        modelSmartLists.push(...modelSmartListData.JsonData.customSmartLists);
                    }
                    if (modelSmartListData.JsonData && modelSmartListData.JsonData.length > 0) {
                        modelSmartLists.push(...modelSmartListData.JsonData);
                    }
                }
                const modelSmartListsWithOriginal = modelSmartLists.map((smartList) => {
                    return {
                        ...smartList,
                        originalFilters: [...smartList.filters],
                        unsaved: false,
                    };
                });
                ls.set('nw_config_model_smartlists', modelSmartListsWithOriginal);

                // stesso Name e stessa forma usati da saveSmartList in ContactsSelectorContext
                const customerSmartListData = userGuiConfigurations.find(
                    (configuration) => configuration.Name === 'customer-custom-smart-lists'
                );
                const customerSmartLists = [...CUSTOMERS_FILTERS_SET.staticSets];
                if (
                    customerSmartListData &&
                    customerSmartListData.JsonData.customSmartLists &&
                    customerSmartListData.JsonData.customSmartLists.length > 0
                ) {
                    customerSmartLists.push(...customerSmartListData.JsonData.customSmartLists);
                }
                const customerSmartListsWithOriginal = customerSmartLists.map((smartList) => {
                    return {
                        ...smartList,
                        originalFilters: [...smartList.filters],
                        unsaved: false,
                    };
                });
                ls.set('nw_config_customer_smartlists', customerSmartListsWithOriginal);

                const eventSmartListData = userGuiConfigurations.find(
                    (configuration) => configuration.Name === 'event-smart-list'
                );
                const eventSmartLists = [...EVENTS_FILTERS_SETS.staticSets];
                if (eventSmartListData && eventSmartListData.JsonData) {
                    let customSetsFromDB = [];
                    try {
                        const jsonData =
                            typeof eventSmartListData.JsonData === 'string'
                                ? JSON.parse(eventSmartListData.JsonData)
                                : eventSmartListData.JsonData;
                        customSetsFromDB = jsonData.smartList || [];
                    } catch (parseError) {
                        console.error('Error parsing event smart list data:', parseError);
                    }
                    if (customSetsFromDB && customSetsFromDB.length > 0) {
                        eventSmartLists.push(...customSetsFromDB);
                    }
                }
                const eventSmartListsWithOriginal = eventSmartLists.map((smartList) => {
                    return {
                        ...smartList,
                        originalFilters: [...smartList.filters],
                        unsaved: false,
                    };
                });
                // Save to localStorage - the EventsSearchProvider will read from here
                const currentConfig = ls.get('nw_config_eventwallfilter') || {};
                ls.set('nw_config_eventwallfilter', {
                    ...currentConfig,
                    customSets: eventSmartListsWithOriginal.filter((s) => !s.fixed),
                });

                // il server vince sul localStorage: ogni salvataggio invia la lista completa
                for (const wallSmartList of WALL_SMART_LISTS) {
                    const wallSmartListData = userGuiConfigurations.find(
                        (configuration) => configuration.Name === wallSmartList.name
                    );
                    if (wallSmartListData) {
                        dispatch({
                            type: wallSmartList.actionType,
                            customSets: wallSmartListData.JsonData.smartList || [],
                        });
                    }
                }
            } else {
                ugc_dispatch({
                    type: 'Update',
                    value: {
                        ...userGuiConfig,
                        metrics: conversions ? conversions.map(buildMetricPref) : [],
                    },
                });
            }
        } catch (error) {
            console.error('Get User Client Configurations Error => ', error);
        }
    };

    useEffect(() => {
        const prefetchContacts = async () => {
            setIsLoading(true);

            if (!prefetched) {
                await prefetchModels();
                await prefetchPlaylistsCount();
                await prefetchContactList();
                await prefetchActivePackages(userContext.currentUser.UserID);
                await prefetchActiveShowSeasons();
                await prefetchCustomers();
                await prefetchFeatures();
                await prefetchFeatureSets();
                await prefetchFolders();
                await prefetchRoomConnections();
                const conversions = await prefetchConversions();
                await getUserClientConfigurations(conversions);
                setPrefetched(true);
            }
        };

        if (userContext.currentUser) {
            prefetchContacts();
        } else {
            if (prefetched) {
                setPrefetched(false);
            }
        }
    }, [userContext.currentUser]);

    // useEffect(() => {
    //     const handleBeforeUnload = () => {
    //         const url = `https://dev2.netwalk.app/api/account/logoff/${userContext.currentUser.UserID}`;
    //         const data = JSON.stringify({ reason: 'tab closed' });
    //         // Importante: il body deve essere un Blob, FormData o ArrayBufferView
    //         const blob = new Blob([data], { type: 'application/json' });

    //         navigator.sendBeacon(url, blob);
    //     };

    //     window.addEventListener('beforeunload', handleBeforeUnload);
    //     return () => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, []);

    return (
        <QueryClientProvider>
            {/* locale={userGuiConfig.calendar.weekFormat === 'monday' ? en_GB : en_US} */}
            <ConfigProvider locale={en_GB}>
                <ThemeProvider theme={StyleVariables}>
                    <Interceptor />

                    {/* VERSIONE CKEDITOR NON USATA */}
                    {/* {isDocumentPage() ? (
                        isLoading && !listContext.cachedListLoaded ? (
                            <DocumentLayout>
                                <RouteLoading />
                            </DocumentLayout>
                        ) : (
                            <Route
                                path="/document/:documentId/objectId/:objectId"
                                element={
                                    <RequireAuth>
                                        <DocEditor />
                                    </RequireAuth>
                                }
                            />
                        )
                    ) : (<></>)} */}

                    {(isLoading && !listContext.cachedListLoaded) || areaContext.areaContactsLoading ? (
                        <NwLayout>
                            <RouteLoading />
                        </NwLayout>
                    ) : (
                        <div>
                            <NwLayout>
                                <Suspense fallback={<RouteLoading />}>
                                    <Routes>
                                        <Route
                                            path="/"
                                            element={
                                                <RequireAuth>
                                                    <BookingDashboard />
                                                </RequireAuth>
                                            }
                                        />

                                        {/* not authenticated routes */}
                                        <Route path="login" element={<Login />} />
                                        <Route path="forgot-password" element={<ForgotPassword />} />
                                        <Route path="reset-password" element={<ResetPassword />} />

                                        {/* authentication and user profile */}
                                        <Route
                                            path="user/*"
                                            element={
                                                <RequireAuth>
                                                    <User />
                                                </RequireAuth>
                                            }
                                        />

                                        <Route
                                            path="user/personal-reports/models"
                                            element={
                                                <RequireAuth>
                                                    <PersonalModelsReport />
                                                </RequireAuth>
                                            }
                                        />

                                        <Route
                                            path="user/personal-reports/clients"
                                            element={
                                                <RequireAuth>
                                                    <PersonalClientsReport />
                                                </RequireAuth>
                                            }
                                        />

                                        {/* e-mail report (links from user icon and management navbar */}

                                        <Route
                                            path="email-report"
                                            element={
                                                <RequireAuth>
                                                    <MailReportPage />
                                                </RequireAuth>
                                            }
                                        />

                                        {/* dashboard and dashboard links */}
                                        <Route
                                            path="dashboard"
                                            element={
                                                <RequireAuth>
                                                    {' '}
                                                    <BookingDashboard />{' '}
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="search-tasks/:contactId?"
                                            element={
                                                <RequireAuth>
                                                    <SearchTasks />
                                                </RequireAuth>
                                            }
                                        />

                                        {/* mobile home */}
                                        <Route
                                            path="mobile-home"
                                            element={
                                                <RequireAuth>
                                                    <MobileHomePage />
                                                </RequireAuth>
                                            }
                                        />

                                        {/* models */}
                                        <Route
                                            path="models/:listType?/:activeSet?"
                                            element={
                                                <RequireAuth>
                                                    <ModelsPage />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="models/actions/:action/:modelToCompare?" ///:listType?/:activeSet?
                                            element={
                                                <RequireAuth>
                                                    <ModelsPage />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="model/:modelId/:listType?/:activeSet?"
                                            element={
                                                <RequireAuth>
                                                    <ModelDetailsResponsive />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="model/:modelId/media/:listType?/:activeSet?"
                                            element={
                                                <RequireAuth>
                                                    <ModelDetailsMedia />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="model/:modelId/newbook/:listType?/:activeSet?"
                                            element={
                                                <RequireAuth>
                                                    <ModelDetailsMedia newBook />
                                                </RequireAuth>
                                            }
                                        />

                                        <Route
                                            path="models-archive"
                                            element={
                                                <RequireAuth>
                                                    <ModelsArchive />
                                                </RequireAuth>
                                            }
                                        />

                                        <Route
                                            path="rooms/*"
                                            // subsections are "reports" and "chart"
                                            element={
                                                <RequireAuth>
                                                    <Rooms />
                                                </RequireAuth>
                                            }
                                        />

                                        <Route
                                            path="models-legal"
                                            element={
                                                <RequireAuth>
                                                    <ModelsLegalSearch />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="model-data-updates/:section?"
                                            element={
                                                <RequireAuth>
                                                    <ModelDataUpdates />
                                                </RequireAuth>
                                            }
                                        />

                                        {/* schedule and bookings (projects) */}
                                        <Route
                                            path="bookings/:projectId/:eventId?/:eventType?"
                                            element={
                                                <RequireAuth>
                                                    <ProjectPage />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="schedule/:listType?/:activeSet?/:modelId?"
                                            element={
                                                <RequireAuth>
                                                    <ScheduleContainerWrapper />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="events-search"
                                            element={
                                                <RequireAuth>
                                                    <EventsSearch />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="events-report"
                                            element={
                                                <RequireAuth>
                                                    <EventsReportPage />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="usages-search"
                                            element={
                                                <RequireAuth>
                                                    <UsagesSearchPage />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="projects-drafts"
                                            element={
                                                <RequireAuth>
                                                    <ProjectDraftsPage />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="show-seasons/:seasonId?"
                                            element={
                                                <RequireAuth>
                                                    <ShowSeasons />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="due"
                                            element={
                                                <RequireAuth>
                                                    <DUEPage />
                                                </RequireAuth>
                                            }
                                        />

                                        {/* packages */}
                                        <Route
                                            path="packages/*" // * = active for active packages, otherwise sent packages
                                            element={
                                                <RequireAuth>
                                                    <Packages />
                                                </RequireAuth>
                                            }
                                        />

                                        {/* contacts (customers) */}
                                        <Route
                                            path="customers/:listType?/:activeSet?"
                                            element={
                                                <RequireAuth>
                                                    <CustomersPage />
                                                </RequireAuth>
                                            }
                                        />
                                        {/* contacts (customers) */}
                                        <Route
                                            path="accounting/agencies"
                                            element={
                                                <RequireAuth>
                                                    <CustomersPage customerType="agency" />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting/clients"
                                            element={
                                                <RequireAuth>
                                                    <CustomersPage customerType="client" />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting/services"
                                            element={
                                                <RequireAuth>
                                                    <CustomersPage customerType="service" />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="customer/:customerId/:listType?/:activeSet?" //
                                            element={
                                                <RequireAuth>
                                                    <CustomerDetailsResponsive />
                                                    {/* {breakpoint === 1
                                                            ?
                                                            <CustomerDetailsMobile />
                                                            :
                                                            <CustomerDetailsHome />
                                                        } */}
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="customers-archive"
                                            element={
                                                <RequireAuth>
                                                    <CustomersArchive />
                                                </RequireAuth>
                                            }
                                        />

                                        {/* mailing lists */}
                                        <Route
                                            path="mailing-lists/:mailingListId?"
                                            element={
                                                <RequireAuth>
                                                    <MailingListsWrapper />
                                                </RequireAuth>
                                            }
                                        />

                                        <Route
                                            path="scouting"
                                            element={
                                                <RequireAuth>
                                                    <ScoutingDashboard />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="scouting/travels"
                                            element={
                                                <RequireAuth>
                                                    <TravelPlansSearch />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="scouting/travel/:travelId"
                                            element={
                                                <RequireAuth>
                                                    <TravelPlan />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="scouting/meetings/:contactId?"
                                            element={
                                                <RequireAuth>
                                                    <ScoutingMeetings />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="scouting/applications/:applicationId?"
                                            element={
                                                <RequireAuth>
                                                    <Applications />
                                                </RequireAuth>
                                            }
                                        />

                                        <Route
                                            path="art"
                                            element={
                                                <RequireAuth>
                                                    <RequirePolicy policyName="AccessArt" fallback="/dashboard">
                                                        {/* al posto di <ArtDashboard />, disabilitata per ora */}
                                                        <Navigate to="/art/website" replace />
                                                    </RequirePolicy>
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="art/website"
                                            element={
                                                <RequireAuth>
                                                    <RequirePolicy policyName="AccessArt" fallback="/dashboard">
                                                        <div className="nw-container">
                                                            <ArtWebsites />
                                                        </div>
                                                    </RequirePolicy>
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="art/news"
                                            element={
                                                <RequireAuth>
                                                    <RequirePolicy policyName="AccessArt" fallback="/dashboard">
                                                        <ArtNews />
                                                    </RequirePolicy>
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="art/articles"
                                            element={
                                                <RequireAuth>
                                                    <RequirePolicy policyName="AccessArt" fallback="/dashboard">
                                                        <ArtArticles />
                                                    </RequirePolicy>
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="art/galleries"
                                            element={
                                                <RequireAuth>
                                                    <RequirePolicy policyName="AccessArt" fallback="/dashboard">
                                                        <ArtGalleries />
                                                    </RequirePolicy>
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="art/uploads"
                                            element={
                                                <RequireAuth>
                                                    <RequirePolicy policyName="AccessArt" fallback="/dashboard">
                                                        <ArtUploads />
                                                    </RequirePolicy>
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="art/model-contents"
                                            element={
                                                <RequireAuth>
                                                    <RequirePolicy policyName="AccessArt" fallback="/dashboard">
                                                        <ArtModelContents />
                                                    </RequirePolicy>
                                                </RequireAuth>
                                            }
                                        />

                                        <Route
                                            path="accounting"
                                            element={
                                                <RequireAuth>
                                                    <AccountingDashboard />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting/model/:modelId"
                                            element={
                                                <RequireAuth>
                                                    <ModelDetailsAccounting />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting/customer/:customerId"
                                            element={
                                                <RequireAuth>
                                                    <CustomerDetailsAccounting />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="billing/projects"
                                            element={
                                                <RequireAuth>
                                                    <BillingProjects />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="billing/expenses"
                                            element={
                                                <RequireAuth>
                                                    <BillingExpenses />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="billing/commissions/:section?"
                                            element={
                                                <RequireAuth>
                                                    <BillingCommissions />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="billing/commissions-test"
                                            element={
                                                <RequireAuth>
                                                    <BillingCommissionsIntegratedSearch />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="invoices"
                                            element={
                                                <RequireAuth>
                                                    <Invoices />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="invoice/:invoiceId?"
                                            element={
                                                <RequireAuth>
                                                    <InvoicePageWrapper />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="payments/:type?"
                                            element={
                                                <RequireAuth>
                                                    <PaymentsWrapper />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="/balance-report/:type?"
                                            element={
                                                <RequireAuth>
                                                    <BalanceReport />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="/statements/search"
                                            element={
                                                <RequireAuth>
                                                    <StatementsSearch />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="massive-expenses"
                                            element={
                                                <RequireAuth>
                                                    <MassiveExpensesWrapper />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting-reports"
                                            element={
                                                <RequireAuth>
                                                    <ClientsReport />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting-reports/clients"
                                            element={
                                                <RequireAuth>
                                                    <ClientsReport />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting-reports/bookers"
                                            element={
                                                <RequireAuth>
                                                    <BookersReport />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting-reports/models"
                                            element={
                                                <RequireAuth>
                                                    <ModelsReport />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting-reports/comm-as-moth-ag"
                                            element={
                                                <RequireAuth>
                                                    <CommissionsAsMotherAgencyReport />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting-reports/mother-agency-commissions"
                                            element={
                                                <RequireAuth>
                                                    <MotherAgencyCommissionsReport />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting-reports/work-dates"
                                            element={
                                                <RequireAuth>
                                                    <WorkDatesReportPage />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting-reports/invoices"
                                            element={
                                                <RequireAuth>
                                                    <InvoicesReport />
                                                </RequireAuth>
                                            }
                                        />
                                        {/* contacts (customers) */}
                                        <Route
                                            path="accounting/customers"
                                            element={
                                                <RequireAuth>
                                                    <CustomersPage />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="accounting/admin/:section"
                                            element={
                                                <RequireAuth>
                                                    <AccountingAdmin />
                                                </RequireAuth>
                                            }
                                        />

                                        {/* TEMP: Removed dashboard as it's empty */}
                                        {/* <Route
                                                path="management"
                                                element={
                                                    <RequireAuth>
                                                        <ManagementDashboard />
                                                    </RequireAuth>
                                                }
                                            /> */}
                                        <Route
                                            path="management"
                                            element={
                                                <RequireAuth>
                                                    <AgenciesDepartments />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="management/models"
                                            element={
                                                <RequireAuth>
                                                    <ManagementModelsPage />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="management/customers"
                                            element={
                                                <RequireAuth>
                                                    <ManagementCustomersPage />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="management/configuration/:section"
                                            element={
                                                <RequireAuth>
                                                    <ConfigurationsPage />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="management/users"
                                            element={
                                                <RequireAuth>
                                                    <UserManagement />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="management/user-policies/:section"
                                            element={
                                                <RequireAuth>
                                                    <UserPoliciesPage />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="management/website"
                                            element={
                                                <RequireAuth>
                                                    <WebsiteManagement />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="management/application-forms"
                                            element={
                                                <RequireAuth>
                                                    <ApplicationFormsManagement />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="management/structure"
                                            element={
                                                <RequireAuth>
                                                    <AgenciesDepartments />
                                                </RequireAuth>
                                            }
                                        />
                                        <Route
                                            path="management/import/:section"
                                            element={
                                                <RequireAuth>
                                                    <ImportDataPage />
                                                </RequireAuth>
                                            }
                                        />

                                        {/*
                                            <PrivateRoute exact path="/management" component={ManagementDashboard} />
                                            <PrivateRoute path="/management-dashboard" component={ManagementDashboard} />

                                            <PrivateRoute path="/user-management" component={UserManagement} />
                                            <PrivateRoute path="/user-policies" component={UserPolicies} />
                                            <PrivateRoute path="/configuration" component={Configuration} />
                                            <PrivateRoute path="/import" component={ImportData} />
                                            <PrivateRoute path="/agencies-departments" component={AgenciesDepartments} /> */}
                                    </Routes>
                                </Suspense>
                            </NwLayout>
                        </div>
                    )}
                </ThemeProvider>
            </ConfigProvider>
        </QueryClientProvider>
    );
};
export default App;
